import { render, staticRenderFns } from "./IssuesTable.vue?vue&type=template&id=d1fb24e0&scoped=true&"
import script from "./IssuesTable.vue?vue&type=script&lang=ts&"
export * from "./IssuesTable.vue?vue&type=script&lang=ts&"
import style0 from "./IssuesTable.vue?vue&type=style&index=0&id=d1fb24e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1fb24e0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDataTable,VDialog})
